<template>
    <kt-row style="margin-bottom: 50px">
        <div v-for="(account,index) in accounts" v-bind:key="index" class="col-12">
            <hr :id="'account_hr_tag'+index">
            <kt-row>
                <kt-col xs="6" sm="5" md="4" lg="3">
                    <p style="font-size: medium;display: inline-block">
                        {{ $t('application.account_detail') }}{{ ' ' }}{{ $i18n.t('ordinal_numbers.' + [index + 1]) }}
                    </p>
                </kt-col>
                <kt-col xs="1" sm="2" md="4" lg="6">
                </kt-col>
                <kt-col xs="5" sm="5" md="4" lg="3">
                    <kt-form-group>
                        <a @click="deleteAccount(index)"
                           class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>

                </kt-col>
            </kt-row>

            <kt-row style="margin-top: 20px">
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_first_name">
                            {{ $t("label.first_name") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="rtl"
                            :name="'accounts.'+index +'.first_name'"
                            :id="'account_first_name'+index"
                            v-model="account.first_name"
                        ></kt-form-control>
                        <p :id="'account_first_name_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_last_name">
                            {{ $t("label.last_name") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="rtl"
                            :name="'accounts.'+index +'.last_name'"
                            :id="'account_last_name'+index"
                            v-model="account.last_name"
                        ></kt-form-control>
                        <p :id="'account_last_name_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_bank_id">
                            {{ $t("label.bank_name") }}
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            class="form-control"
                            :name="'accounts.'+index +'.bank_id'"
                            :id="'account_bank_id'+index"
                            v-model="account.bank_id"
                        >
                            <option
                                v-bind:key="bank_id"
                                v-for="(bank_id, index) in banks"
                                v-bind:value="bank_id"
                            >
                                {{ $t("wallets.bank." + index) }}
                            </option>
                        </kt-form-select>
                        <p :id="'account_bank_id_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_account_number">
                            {{ $t("label.account_number") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.account_number'"
                            :id="'account_account_number'+index"
                            v-model="account.account_number"
                        ></kt-form-control>
                        <p :id="'account_account_number_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_iban">
                            {{ $t("label.iban") }}
                        </kt-form-label>
                        <kt-form-control
                            style="direction: ltr"
                            class="form-control sheba"
                            :name="'accounts.'+index +'.iban'"
                            :id="'account_iban'+index"
                            v-model="account.iban"
                        ></kt-form-control>
                        <p :id="'account_iban_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_shahab_code">
                            {{ $t("open_banking.shahab_code") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.shahab_code'"
                            :id="'account_shahab_code'+index"
                            v-model="account.shahab_code"
                        ></kt-form-control>
                        <p :id="'shahab_code_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </div>
        <div class="col-12">
            <kt-col xs="7" sm="5" md="4" lg="3" style="position: absolute;left:0;top: 20px">
                <div @click="addAccount"
                     class="kt-nav__link m-2 btn btn-outline-primary float-right">
                    + {{ $t('application.add_new_account') }}
                </div>

            </kt-col>
        </div>
        <hr>
    </kt-row>
</template>

<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import IranSheba from 'iran-sheba'
import Inputmask from "inputmask";


export default {
    props: {
        accounts: {
            required: true,
            type: Array
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.afterDispatch()
        this.initShebaMask()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        initShebaMask() {
            setTimeout(() => {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.sheba'))
            }, 500)
        },
        addAccount() {
            this.accounts.push({
                bank_id: '',
                account_number: '',
                first_name: this.accounts[0].first_name,
                last_name: this.accounts[0].last_name,
                iban: '',
                shahab_code: '',
            });
            this.initShebaMask()
        },
        deleteAccount(index) {
            this.accounts.splice(index, 1)
        },
    },
    data() {
        return {
            banks: {
                keshavarzi: '016',
                saderat: '019',
                saman: '056',
            }
        }
    }
}
</script>

<style>

</style>